"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _get = _interopRequireDefault(require("lodash/get"));
var _colors = require("@material-ui/core/colors");
var _core = require("@material-ui/core");
var _styles = require("@material-ui/core/styles");
var _clsx = _interopRequireDefault(require("clsx"));
var _helpers = require("../utilities/helpers");
const _excluded = ["title", "classes"];
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function (e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != typeof e && "function" != typeof e) return {
    default: e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n.default = e, t && t.set(e, n), n;
}
const useClasses = (0, _styles.makeStyles)(({
  palette,
  zIndex
}) => ({
  root: {
    position: 'absolute',
    top: '-100%',
    left: '-100%',
    backgroundColor: palette.common.black,
    color: palette.common.white,
    '&:hover': {
      backgroundColor: _colors.grey[800]
    },
    '&:focus': {
      position: 'fixed',
      top: '1rem',
      left: '1rem',
      zIndex: zIndex.tooltip
    }
  },
  focusVisible: {
    position: 'fixed',
    top: '1rem',
    left: '1rem',
    zIndex: zIndex.tooltip,
    outline: `2px solid ${palette.common.white}`
  }
}), {
  classNamePrefix: 'TCUISkipMenuButton'
});
const onClick = () => {
  let focusable = document.getElementsByTagName('main')[0];
  if (focusable) {
    focusable.focus();
    return;
  }
};
const SkipMenuButton = _ref => {
  let {
      title,
      classes
    } = _ref,
    rest = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
  const _classes = useClasses();
  const buttonRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    const handleSelection = () => {
      if ((0, _get.default)(document.getSelection(), 'focusNode.parentNode.parentNode') === buttonRef.current) {
        buttonRef.current.focus();
      }
    };
    document.addEventListener('selectionchange', handleSelection);
    return () => {
      document.removeEventListener('selectionchange', handleSelection);
    };
  }, []);
  return /*#__PURE__*/_react.default.createElement(_core.Button, (0, _extends2.default)({}, rest, {
    "aria-label": title,
    onClick: onClick,
    variant: "contained",
    ref: buttonRef,
    classes: {
      root: (0, _clsx.default)(_classes.root, classes.root),
      focusVisible: (0, _clsx.default)(_classes.focusVisible, classes.focusVisible)
    }
  }), title);
};
SkipMenuButton.propTypes = {
  title: _propTypes.default.string.isRequired,
  classes: _propTypes.default.object
};
SkipMenuButton.defaultProps = {
  classes: {}
};
var _default = exports.default = SkipMenuButton;